module.exports = __webpack_public_path__ + "videos/hero-vid_cn.466d686.mp4";